function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// preview immagini nella scheda
	const gallery_preview = document.querySelector("#_gallery-preview");
	if (gallery_preview) {
		import("../../common/image_gallery.js").then((module) => {
			const MovieFreeGLightbox = module.MovieFreeGLightbox;
			const images = [];
			for (const el of document.querySelectorAll("._gallery_img")) {
				images.push({ href: el.dataset.gallerySrc });
			}
			new MovieFreeGLightbox({
				elements: images,
				selector: "#_gallery-preview ._gallery_img",
			});
		});
	}

	if (document.querySelector("#news")) {
		// Aggiornamento data articoli
		import("../../common/pubdate.js");
	}
});
